export const getScopedLocalStorageKey = (baseKey, accountId, userId) => {
    if (!baseKey || !accountId || !userId) return null
    return `${baseKey}:${accountId}:${userId}`
}

export const getScopedLocalStorageValue = (baseKey, accountId, userId, legacyValue, consumeLegacy = false) => {
    const scopedKey = getScopedLocalStorageKey(baseKey, accountId, userId)
    if (!scopedKey || typeof window === "undefined") return legacyValue ?? null

    const scopedValue = window.localStorage.getItem(scopedKey)
    if (scopedValue !== null) return scopedValue

    if (legacyValue !== undefined && legacyValue !== null) {
        window.localStorage.setItem(scopedKey, legacyValue)
        if (consumeLegacy) window.localStorage.removeItem(baseKey)
        return legacyValue
    }

    return null
}

export const setScopedLocalStorageValue = (baseKey, accountId, userId, value) => {
    const scopedKey = getScopedLocalStorageKey(baseKey, accountId, userId)
    if (!scopedKey || typeof window === "undefined") return false
    window.localStorage.setItem(scopedKey, value)
    return true
}

export const removeScopedLocalStorageValue = (baseKey, accountId, userId) => {
    const scopedKey = getScopedLocalStorageKey(baseKey, accountId, userId)
    if (!scopedKey || typeof window === "undefined") return false
    window.localStorage.removeItem(scopedKey)
    return true
}
